import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IAuthorizationRepository } from '../entities/IAuthorizationRepository';
import { IAuthorizationService } from '../entities/IAuthorizationService';
import { InitiateMandate, Mandate, MandatePayroll, PendingAuthorizations } from '../entities';
import { ExecuteMandateResponseBody } from '../entities/ExecuteMandateResponseDTO';
import { CheckMandateResponseBody } from '../entities/CheckMandateResponseDTO';
import { InitiateMandateRequest } from '../entities/types';
import { InitiateMandateResponseBody } from '../entities/InitiateMandateResponseDTO';

export default class AuthorizationServiceImpl implements IAuthorizationService {
  itemRepo: IAuthorizationRepository;

  constructor(ir: IAuthorizationRepository) {
    this.itemRepo = ir;
    this.GetAuthorizations = this.GetAuthorizations.bind(this);
    this.GetPayrolls = this.GetPayrolls.bind(this);
    this.ExecuteMandate = this.ExecuteMandate.bind(this);
    this.CheckMandate = this.CheckMandate.bind(this);
    this.InitiateMandate = this.InitiateMandate.bind(this);
    this.InitiateBulkMandates = this.InitiateBulkMandates.bind(this);
    this.ExecuteBulkMandates = this.ExecuteBulkMandates.bind(this);
    this.GetPendingAuthorizations = this.GetPendingAuthorizations.bind(this);
  }

  GetAuthorizations(params: { customerId?: string | null }): Promise<Mandate[]> {
    return this.itemRepo.GetAuthorizations(params?.customerId);
  }

  GetPayrolls(params: { customerId?: string }): Promise<MandatePayroll[]> {
    return this.itemRepo.GetPayrolls(params?.customerId);
  }

  ExecuteMandate(params: { requestId: string; successCallback: SuccessCallback }): Promise<ExecuteMandateResponseBody> {
    return this.itemRepo.ExecuteMandate(params.requestId, params.successCallback);
  }

  CheckMandate(params: { accountNumber: string; uniqueId: number; amount: number }): Promise<CheckMandateResponseBody> {
    return this.itemRepo.CheckMandate(params.accountNumber, params.uniqueId, params.amount);
  }

  InitiateMandate(params: InitiateMandateRequest): Promise<InitiateMandateResponseBody> {
    return this.itemRepo.InitiateMandate(
      params.appTransactionId,
      params.accepted,
      params.orderCode,
      params.dealerRateRequest,
      params.cancellationReason,
    );
  }

  InitiateBulkMandates(params: { customerId: string; mandates: InitiateMandateRequest[] }): Promise<InitiateMandate> {
    return this.itemRepo.InitiateBulkMandates(params.customerId, params.mandates);
  }

  ExecuteBulkMandates(params: { requestId: string; successCallback: SuccessCallback }): Promise<{}> {
    return this.itemRepo.ExecuteBulkMandates(params.requestId, params.successCallback);
  }

  GetPendingAuthorizations(params: {
    customerId: string;
    fromOrderAmountFilter: number;
    toOrderAmountFilter: number;
    fromTrxDate: string;
    toTrxDate: string;
  }): Promise<PendingAuthorizations> {
    return this.itemRepo.GetPendingAuthorizations(
      params.customerId,
      params.fromOrderAmountFilter,
      params.toOrderAmountFilter,
      params.fromTrxDate,
      params.toTrxDate,
    );
  }
}
